import React, { createContext, useContext, useState, useMemo } from "react";

const CompassCtx = createContext(null);

const empty = {
  path: null,        // "idea" | "negocio"
  country: null,
  state: null,
  city: null,
  answers: {},
};

export function CompassProvider({ children }) {
  const [draft, setDraft] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("ruta_compass_draft")) || empty; }
    catch { return empty; }
  });

  const update = (patch) => setDraft((d) => {
    const next = { ...d, ...patch };
    try { sessionStorage.setItem("ruta_compass_draft", JSON.stringify(next)); } catch {}
    return next;
  });

  const setAnswer = (key, value) => update({ answers: { ...draft.answers, [key]: value } });

  const reset = () => {
    setDraft(empty);
    try { sessionStorage.removeItem("ruta_compass_draft"); } catch {}
  };

  const value = useMemo(() => ({ draft, update, setAnswer, reset }), [draft]);
  return <CompassCtx.Provider value={value}>{children}</CompassCtx.Provider>;
}

export function useCompass() { return useContext(CompassCtx); }
